import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteEmployee as apiFn } from "../../api/apiEmployees";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteEmployee() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: forceDeleteEmployee, isPending: isForceDelete } = useMutation({
        mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["employees"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { forceDeleteEmployee, isForceDelete };
}
